import { isUndefinedOrEmpty } from '@afterpay/utils'
import { AllCountryCode } from '@afterpaytouch/core'

export const POSTCODE_REGEX_VALIDATION: {
  [x: string]: { validPostcodeRegex: RegExp; removeSpaces: boolean; allowedRegex?: RegExp; restrictedRegex?: RegExp }
} = {
  AU: {
    validPostcodeRegex: /^\d{4}$/,
    removeSpaces: true,
  },
  NZ: {
    validPostcodeRegex: /^\d{4}$/,
    removeSpaces: true,
  },
  US: {
    validPostcodeRegex: /^(\d{5}|\d{5}-\d{4})$/,
    removeSpaces: true,
  },
  CA: {
    validPostcodeRegex: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/,
    removeSpaces: true,
  },
  GB: {
    validPostcodeRegex: /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2})$/,
    allowedRegex:
      /^(AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GU|HA|HD|HG|HP|HR|HU|HS|HX|IG|IP|IV|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE).*$/i,
    restrictedRegex: /^(AI|AS|BBN|BF|BI|BX|IM|JE|FI|GY|GX|GIR|PC|SI|STH|TDC|TK|QC|XX).*$/i,
    removeSpaces: false,
  },
  IM: {
    validPostcodeRegex: /^IM[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i,
    removeSpaces: false,
  },
  JE: {
    validPostcodeRegex: /^JE[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i,
    removeSpaces: false,
  },
  GG: {
    validPostcodeRegex: /^GY[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i,
    removeSpaces: false,
  },
  NL: {
    validPostcodeRegex: /^(?:NL-)?\d{4}\s{0,1}[A-Za-z]{2}$/i,
    removeSpaces: false,
  },
  CN: {
    validPostcodeRegex: /^\d{6}$/i,
    removeSpaces: true,
  },
  LV: {
    validPostcodeRegex: /^[Ll][Vv][- ]{0,1}\d{4}$/i,
    removeSpaces: false,
  },
  FR: {
    validPostcodeRegex: /^\d{5}$/i,
    removeSpaces: true,
  },
  GI: {
    validPostcodeRegex: /^[Gg][Xx][1]{2}\s{0,1}[1][Aa]{2}$/i,
    removeSpaces: false,
  },
  GR: {
    validPostcodeRegex: /^\d{3}\s{0,1}\d{2}$/i,
    removeSpaces: false,
  },
  IE: {
    validPostcodeRegex: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/i,
    removeSpaces: false,
  },
  NO: {
    validPostcodeRegex: /^\d{4}$/i,
    removeSpaces: true,
  },
  HK: {
    validPostcodeRegex: /^HKG$/i,
    removeSpaces: true,
  },
  AE: {
    validPostcodeRegex: /^UAE$/i,
    removeSpaces: true,
  },
  DE: {
    validPostcodeRegex: /^\d{5}$/i,
    removeSpaces: true,
  },
  IT: {
    validPostcodeRegex: /^\d{5}$/i,
    removeSpaces: true,
  },
  ES: {
    validPostcodeRegex: /^\d{5}$/i,
    removeSpaces: true,
  },
}

export const isValidPostcode = (country: AllCountryCode | undefined, postcode: string | undefined, optional: boolean = false): boolean => {
  if (optional && (isUndefinedOrEmpty(postcode) || postcode === country)) {
    return true
  }
  if (isUndefinedOrEmpty(postcode)) {
    return false
  }
  if (country === undefined) {
    return false
  }

  let isValid = optional
  let isAllowed = true
  let isRestricted = false
  const regexRules = POSTCODE_REGEX_VALIDATION[country]

  if (regexRules !== undefined) {
    postcode = regexRules.removeSpaces ? postcode?.replace(/\s+/g, '') : postcode
    isValid = regexRules.validPostcodeRegex.test(postcode ?? '')

    if (regexRules.allowedRegex !== undefined) {
      isAllowed = regexRules.allowedRegex.test(postcode ?? '')
    }

    if (regexRules.restrictedRegex !== undefined) {
      isRestricted = regexRules.restrictedRegex.test(postcode ?? '')
    }
  }

  return isValid && isAllowed && !isRestricted
}
